// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuotesPage {
  width: 100%;
  min-height: 100vh;
}

/* View Mode Switcher */
.adv-quotes-switcher {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background-color: #0e1b1b;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  width: fit-content;
}

.adv-quotes-switch-btn {
  padding: 8px 22px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #777;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  transition: all 0.2s ease;
}

.adv-quotes-switch-btn--active {
  background-color: #3bb3ae;
  color: #071414;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/QuotesPage/QuotesPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".QuotesPage {\n  width: 100%;\n  min-height: 100vh;\n}\n\n/* View Mode Switcher */\n.adv-quotes-switcher {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  background-color: #0e1b1b;\n  padding: 6px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  width: fit-content;\n}\n\n.adv-quotes-switch-btn {\n  padding: 8px 22px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: #777;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  transition: all 0.2s ease;\n}\n\n.adv-quotes-switch-btn--active {\n  background-color: #3bb3ae;\n  color: #071414;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
